import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Checkbox } from 'primereact/checkbox';
import { injectIntl } from 'react-intl';
import { TOGGLE_ALLOW_LOCAL_FIELDS } from './mutations';
import messages from './intl-messages';
import { withGrowl } from '../../../components/GrowlNotifications';
import { Loading } from '../../../components/Loading';


const ManageAllowLocalFieldsUse = ({
  currentAccount, data, intl: { formatMessage }, growl,
}) => {
  const [subaccountsAllowed, setSubaccountsAllowed] = useState(false);

  const [toggleAllowLocalFieldsUse, toggleAllowLocalFieldsUseResult] = useMutation(
    TOGGLE_ALLOW_LOCAL_FIELDS, { refetchQueries: ['getAccount'] },
  );

  useEffect(() => {
    setSubaccountsAllowed(data.account.subAccountsLocalFieldUseEnabled);
  }, [data]);

  return (
    <div
      className="p-grid p-align-center"
      style={{ borderBottom: '1px dashed black' }}
    >
      <div className="p-col-12">
        <small>
          {formatMessage(messages.allowSubaccountsLocalFieldUseQuestion)}
        </small>

        <label htmlFor="cb" className="p-checkbox-label">
          {subaccountsAllowed
            ? formatMessage(messages.allowLocalFieldUseYesLabel)
            : formatMessage(messages.allowLocalFieldUseNoLabel)}
        </label>

        {
          toggleAllowLocalFieldsUse.loading ? (
            <Loading />
          )
            : (
              <Checkbox
                style={{ marginLeft: '5px' }}
                inputId="cb"
                disabled={toggleAllowLocalFieldsUseResult.loading}
                checked={subaccountsAllowed}
                onChange={() => {
                  const input = {
                    accountId: currentAccount,
                    canUseLocalAriFields: !subaccountsAllowed,
                  };

                  setSubaccountsAllowed(!subaccountsAllowed);
                  toggleAllowLocalFieldsUse({ variables: { input } })
                    .then(() => {
                      growl.show({
                        severity: 'success',
                        summary: formatMessage(messages.growlToggleAllowSubaccountsFieldUseSummary),
                        detail: formatMessage(messages.growlToggleAllowSubaccountsFieldUseSuccess),
                        sticky: false,
                      });
                    })
                    .catch(() => {
                      setSubaccountsAllowed(subaccountsAllowed);
                      growl.show({
                        severity: 'error',
                        summary: formatMessage(messages.growlToggleAllowSubaccountsFieldUseSummary),
                        detail: formatMessage(messages.growlToggleAllowSubaccountsFieldUseFail),
                        sticky: true,
                      });
                    });
                }}
              />
            )
        }
      </div>
    </div>
  );
};

ManageAllowLocalFieldsUse.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectIntl(withGrowl(ManageAllowLocalFieldsUse));
